import React, { useRef } from "react";
import type { Destination } from "@whatslly/types/messages-server/destinations";
import { DESTINATION_INTEGRATION_TYPES } from "@whatslly/types/messages-server/destinations";
import { FormElement } from "@whatslly/ui-components/v2/FormElements/Form";
import { FormikProps } from "formik";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { useTranslation } from "react-i18next";
import type { DestinationFormProps } from "../utils/DestinationsListTypes";
const BASE_DATA: Destination = {
  type: "internalMongoDb" as const,
  integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  settings: {} as Record<string, string>,
};
export const InternalMongoDbModalForm: React.FC<DestinationFormProps<"internalMongoDb">> = ({ onSubmitForm, settings }) => {
  const { t } = useTranslation();
  const formikContext = useRef<FormikProps<Record<string, string>>>(null);

  return (
    <FormElement initialValues={settings || {}} onSubmit={(data) => onSubmitForm({ ...BASE_DATA, settings: { ...data } })} formikRef={formikContext}>
      <div>Save to enable internal Mongo DB integration</div>
      <ModalButtons
        submitText={t("destinations_page.save")}
        testId={"destination-ok-button"}
        onSubmit={() => formikContext.current?.submitForm()}
        hideCancel={true}
      />
    </FormElement>
  );
};
